import React from 'react';
import { injectIntl } from 'react-intl';
import { Formik, Form } from 'formik';
// logic
import useQuoteForm from './useQuoteForm';
// components
//
import TicketFormContainer from '../ui/containers/ticketFormContainer';
//
import { QuoteFormFooter } from './quoteFormFooter';
import QuoteFormBody from './quoteFormBody';

const QuoteForm = ({ quoteFormData, className }) => {
  const {
    // quoteFormSettings,
    ticketDetail,
    onSubmit,
    onCancel,
    onAcceptQuote,
    onRejectQuote,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isStateEdit,
    quoteDetail,
  } = quoteFormData;

  const { showErrors, setShowErrors, isWaitingForResponse, backendErrors, beforeOnSubmit } =
    useQuoteForm({ onSubmit });

  return (
    <TicketFormContainer className={className}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={beforeOnSubmit()}
      >
        {({ errors, dirty, values, submitForm: submitFormikForm, setFieldValue }) => {
          const quoteFormBodyData = {
            backendErrors,
            isEdit,
            isReadOnly,
            isWaitingForResponse,
            quoteDetail,
            setFieldValue,
            showErrors,
            ticketDetail,
            values,
          };
          const quoteFormFooterData = {
            backendErrors,
            setShowErrors,
            isWaitingForResponse,
            submitFormikForm,
            onCancel,
            onAcceptQuote,
            onRejectQuote,
            isEdit,
            isStateEdit,
            isReadOnly,
            dirty,
            quoteDetail,
          };
          return (
            <Form>
              <QuoteFormBody quoteFormBodyData={quoteFormBodyData} />
              <QuoteFormFooter quoteFormFooterData={quoteFormFooterData} />
            </Form>
          );
        }}
      </Formik>
    </TicketFormContainer>
  );
};

export default injectIntl(QuoteForm);
